import { useQuery } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api'

export interface MemberResponse {
  id: string
  name: string
  email: string | null
}

export function useMember(uid: string | undefined) {
  const call = useApiFetch()
  return useQuery({
    queryKey: ['member', uid],
    queryFn: () => {
      if (!uid) throw new Error('uid is required')
      return call<MemberResponse>(`/clubhouse/members/${uid}`)
    },
    enabled: !!uid,
    staleTime: 5 * 60 * 1000,
    // A missing member is deterministic (a 404, not a transient error), and the
    // caller falls back to the auth displayName / "Hunter". Without this, react
    // query's default retry: 3 turns one miss into ~4 identical 404 requests.
    retry: false,
  })
}
